import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';

export default function ReturnsPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="returns-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-5 md:px-8 py-16 md:py-24">
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">Policies</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold mb-8" data-testid="returns-title">
          Returns & Cancellations
        </h1>
        <div className="space-y-6 text-foreground/70 leading-relaxed" data-testid="returns-policy-content">
          <p>
            Each SŌHM piece is prepared against a confirmed order. Please review product details,
            purity, weight, pricing, and delivery information before completing payment.
          </p>
          <p className="text-foreground font-semibold">
            Made-to-order and custom jewellery cannot be cancelled, returned or exchanged after order confirmation.
          </p>
          <p>
            If an item arrives damaged or differs from the confirmed order, contact us promptly with
            the order ID and supporting photographs so our team can review the issue.
          </p>
        </div>
        <div className="flex flex-wrap gap-3 mt-10">
          <Link to="/contact" data-testid="returns-contact-link">
            <Button>Contact Support</Button>
          </Link>
          <Link to="/" data-testid="returns-home-link">
            <Button variant="outline">Back to Home</Button>
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}